import { useEffect, useState } from 'react';
import '../../assets/core.css';
import apiAdm from "../../services/apiAdm.js";
import './dashboard.css'
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Bar, Doughnut, Line } from "react-chartjs-2";



function Dashboard() {

    const [recebidaTotal, setRecebidaTotal] = useState(0);
    const [recebidaAutorizada, setRecebidaAutorizada] = useState(0);
    const [recebidaCancelada, setRecebidaCancelada] = useState(0);
    const [recebidaValor, setRecebidaValor] = useState(0);

    const [emitidaTotal, setEmitidaTotal] = useState(0);
    const [emitidaAutorizada, setEmitidaAutorizada] = useState(0);
    const [emitidaCancelada, setEmitidaCancelada] = useState(0);
    const [emitidaValor, setEmitidaValor] = useState(0);
 
    const [nfcTotal, setNfcTotal] = useState(0);
    const [nfcAutorizada, setNfcAutorizada] = useState(0);
    const [nfcCancelada, setNfcCancelada] = useState(0);
    const [nfcValor, setNfcValor] = useState(0);

    const [cteTotal, setCteTotal] = useState(0);
    const [cteAutorizada, setCteAutorizada] = useState(0);
    const [cteCancelada, setCteCancelada] = useState(0);
    const [cteValor, setCteValor] = useState(0);
    
    const [semanaData, setSemanaData] = useState([]);
    const [tipoData, setTipoData] = useState([]);
    const [anoData, setAnoData] = useState([]);
    const [anoAnterior, setAnoAnterior] = useState(0);
    const [anoAtual, setAnoAtual] = useState(0);

    const [labelDashboard, setLabelDashboard] = useState('Dashboard');


    function Hoje() {
        const hoje = new Date();
        const d1 = hoje.getFullYear() + "-" + ('0' + parseInt(hoje.getMonth() + 1)).slice(-2) + "-" + ('0' + hoje.getDate()).slice(-2) + " 00:00:00";
        const d2 = hoje.getFullYear() + "-" + ('0' + parseInt(hoje.getMonth() + 1)).slice(-2) + "-" + ('0' + hoje.getDate()).slice(-2) + " 23:59:59";
        Montar(d1, d2, 'Dashboard - hoje');
    };

    function MesAtual() {
        const hoje = new Date();
        const firstDay = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        const d1 = firstDay.getFullYear() + "-" + ('0' + parseInt(firstDay.getMonth() + 1)).slice(-2) + "-" + ('0' + firstDay.getDate()).slice(-2) + " 00:00:00";;

        const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        const d2 = lastDay.getFullYear() + "-" + ('0' + parseInt(lastDay.getMonth() + 1)).slice(-2) + "-" + ('0' + lastDay.getDate()).slice(-2) + " 23:59:59";

        Montar(d1, d2, 'Dashboard - mes atual');
    };

    function MesAnterior() {
        const hoje = new Date();
        const firstDay = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        const d1 = firstDay.getFullYear() + "-" + ('0' + parseInt(firstDay.getMonth() + 1)).slice(-2) + "-" + ('0' + firstDay.getDate()).slice(-2) + " 00:00:00";;

        const lastDay = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
        const d2 = lastDay.getFullYear() + "-" + ('0' + parseInt(lastDay.getMonth() + 1)).slice(-2) + "-" + ('0' + lastDay.getDate()).slice(-2) + " 23:59:59";
        Montar(d1, d2, 'Dashboard - mes anterior');
    };

    function Montar(data1, data2, label) {
        setLabelDashboard('Montando dashboard...');
        const json = {
            idEntidade: localStorage.getItem('idEmpresa'),
            data1: data1,
            data2: data2
        };
        apiAdm.post("/xmlresumo/dashboard", json)
            .then((resp) => {
                setLabelDashboard(label)
                console.log(resp.data);
                setRecebidaTotal(resp.data.data.recTotal);
                setRecebidaAutorizada(resp.data.data.recAutorizada);
                setRecebidaCancelada(resp.data.data.recCancelada);
                setRecebidaValor(
                    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resp.data.data.recValor)
                );

                setEmitidaTotal(resp.data.data.emiTotal);
                setEmitidaAutorizada(resp.data.data.emiAutorizada);
                setEmitidaCancelada(resp.data.data.emiCancelada);
                setEmitidaValor(
                    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resp.data.data.emiValor));

                setNfcTotal(resp.data.data.nfcTotal);
                setNfcAutorizada(resp.data.data.nfcAutorizada);
                setNfcCancelada(resp.data.data.nfcCancelada);
                setNfcValor(
                    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resp.data.data.nfcValor));

                setCteTotal(resp.data.data.cteTotal);
                setCteAutorizada(resp.data.data.cteAutorizada);
                setCteValor(
                    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(resp.data.data.cteValor));
 
                setSemanaData(resp.data.data.semana);
                setTipoData(resp.data.data.totalTipo);
                setAnoData(resp.data.data.anoData);

                setAnoAnterior(resp.data.data.anoAnterior);
                setAnoAtual(resp.data.data.anoAtual);
                console.log(resp.data.data);
           })
            .catch((err) => {
                // SweetAlertError({ texto: 'Erro ao carregar os daddos' });
            });
    };

    useEffect(() => {
        Hoje();
    }, []);

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="col py-4 me-3">
                    <div className="d-flex justify-content-between">
                        <h4 className="text-muted mb-3">{labelDashboard}</h4>

                        <div className="row">
                            <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>
                                <div className="btn-group" role="group">
                                    <button className="btn btn-outline-primary me-2" onClick={() => Hoje()}>
                                        Hoje
                                    </button>

                                    <button className="btn btn-outline-primary me-2" onClick={() => MesAtual()}>
                                        Mes atual
                                    </button>
                                    <button className="btn btn-outline-primary me-2" onClick={() => MesAnterior()}>
                                        Mes anterior
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <br></br>
                    <div className="container-card">

                        <div className="card card-new" style={{width: '270px'}} id="new-clients-card">
                            <div className="card-header">
                                {/* <span className="card-title" >NF-e Recebidas</span> */}
                                <h4 className="card-text" style={{ textTransform: 'none' }} >NF-e Entradas</h4>
                                <div className="card-icon">
                                    <i className="fa-solid fa-user-plus"></i>
                                </div>
                            </div>
                            <div className="card-description">Total de notas: {recebidaTotal}</div>
                            <div className="card-description">Autorizadas: {recebidaAutorizada}</div>
                            <div className="card-description">Canceladas: {recebidaCancelada}</div>
                            <div className="card-description">Valor Total: {recebidaValor}</div>

                        </div>

                        <div className="card card-returning" style={{width: '270px'}} id="returning-clients-card">
                            <div className="card-header">
                                <h4 className="card-text" style={{ textTransform: 'none' }} >NF-e Saídas</h4>
                                <div className="card-icon">
                                    <i className="fa-solid fa-user-check"></i>
                                </div>

                            </div>
                            <div className="card-description">Total de notas: {emitidaTotal}</div>
                            <div className="card-description">Autorizadas: {emitidaAutorizada}</div>
                            <div className="card-description">Canceladas: {emitidaCancelada}</div>
                            <div className="card-description">Valor Total: {emitidaValor}</div>

                        </div>

                        <div className=" card text-white bg-success" style={{width: '270px'}} >
                            <div className="card-header">
                                <h4 className="card-text" style={{ textTransform: 'none' }} >NFC-e Emitidas</h4>
                                <div className="card-icon">
                                    <i className="fa-solid fa-user-slash"></i>
                                </div>
                            </div>
                            <div className="card-description">Total de notas: {nfcTotal}</div>
                            <div className="card-description">Autorizadas: {nfcAutorizada}</div>
                            <div className="card-description">Canceladas: {nfcCancelada}</div>
                            <div className="card-description">Valor Total: {nfcValor}</div>
                        </div>
                        <div className="card card-inactive" style={{width: '270px'}} id="inactive-clients-card">
                            <div className="card-header">
                                <h4 className="card-text" style={{ textTransform: 'none' }} >CT-e</h4>
                                <div className="card-icon">
                                    <i className="fa-solid fa-user-slash"></i>
                                </div>
                            </div>
                            <div className="card-description">Total de CT-e: {cteTotal}</div>
                            <div className="card-description">Autorizadas: {cteAutorizada}</div>
                            <div className="card-description">Canceladas: {cteCancelada}</div>
                             <div className="card-description">Valor Total: {cteValor}</div>
                        </div>

                    </div>


                </div>
            </div>

             <div className="row">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="col py-4 me-3">
               <div className="d-flex justify-content-between">
                     <div className="dataCard customerCard">
                        <Bar
                            data={{
                                labels: semanaData.map((data) => data.label),
                                datasets: [
                                    {
                                        label: "Quantidade de NF-e de saídas na semana",
                                        data: semanaData.map((data) => data.value),
                                        backgroundColor: [
                                            "rgba(80, 43, 229, 0.8)",
                                            // "rgba(250, 192, 19, 0.8)",
                                            // "rgba(253, 135, 135, 0.8)",
                                        ],
                                        borderRadius: 5,
                                    },
                                ],
                            }}
                            options={{
                                plugins: {
                                    title: {
                                        text: "Semana atual",
                                    },
                                },
                            }}
                        />
                    </div>

                    <div className="dataCard categoryCard">
                        <Doughnut
                            data={{
                                labels: tipoData.map((data) => data.nome),
                                datasets: [
                                    {
                                        label: "Total notas autorizadas: ",
                                        data: tipoData.map((data) => data.qtda),
                                        backgroundColor: [
                                            "rgba(43, 63, 229, 0.8)",
                                            "rgba(250, 192, 19, 0.8)",
                                            "rgba(253, 135, 135, 0.8)",
                                            "rgba(74, 66, 66, 0.8)",

                                        ],
                                        borderColor: [
                                            "rgba(43, 63, 229, 0.8)",
                                            "rgba(250, 192, 19, 0.8)",
                                            "rgba(253, 135, 135, 0.8)",
                                            "rgba(74, 66, 66, 0.8)",
                                       ],
                                    },
                                ],
                            }}
                            options={{
                                plugins: {
                                    title: {
                                        text: "Revenue Sources",
                                    },
                                },
                            }}
                        />
                    </div>
                </div>
                </div>
            </div>

           
            {/* <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="col py-4 me-3">
                    <Line
                        data={{
                            labels: anoData.map((data) => data.nomeMes),
                            datasets: [
                                {
                                    label: anoAnterior,
                                    data: anoData.map((data) => data.qAnterior),
                                    backgroundColor: "#4806f0ff",
                                    borderColor: "#4806f0ff",
                                },
                                {
                                    label: anoAtual,
                                    data: anoData.map((data) => data.qAtual),
                                    backgroundColor: "#ef5903ef",
                                    borderColor: "#ef5903ef",
                                },
                            ],
                        }}
                        options={{
                            elements: {
                                line: {
                                    tension: 0.5,
                                },
                            },
                            plugins: {
                                title: {
                                    text: "Comparativo",
                                },
                            },
                        }}
                    />

                </div>
            </div> */}

        </div >
    </>
};
export default Dashboard;
